var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('moods-page-style',{attrs:{"title":_vm.$t(("strings." + _vm.context + ".nav.nav_about")),"left-text":_vm.$t(("strings." + _vm.context + ".about.left_text")),"right-text":_vm.$t(("strings." + _vm.context + ".about.right_text"))}})}
var staticRenderFns = []

export { render, staticRenderFns }